import React, { useState, useEffect } from "react";

import * as firebase from "firebase/app";

import { useCollectionData } from "react-firebase-hooks/firestore";
import NewPostForm from "./newPostForm";
import GameVignette from "../gameVignette";

const NewPost = (props) => {
  const [gamesList] = useCollectionData(
    firebase.firestore().collection(`gamesList`)
  );

  const [selectGameId, setSelectGameId] = useState(props.selectGameId);

  useEffect(() => {
    if (props.postValue) {
      setSelectGameId(props.postValue.id_game);
    }
  }, [props]);

  return (
    <div className="newPost absForm">
      <div className="absForm__container newPost__container">
        <button
          onClick={() => props.setNewPostTrigger(false)}
          className="btn--close"
        >
          Fermer
        </button>

        <div className="absForm__content newPost__content ">
          <h2 className="newPost__title">Poster une annonce</h2>
          <div className="newPost__el">
            <h3 className="newPost__subTitle">Choisi un jeu</h3>
            <ul className="gamesList__list">
              {gamesList &&
                gamesList.map((game, key) => (
                  <li
                    onClick={() => setSelectGameId(game.game_id)}
                    key={key}
                    className={`gamesList__el ${
                      selectGameId === game.game_id && "gamesList__el--focus"
                    } `}
                  >
                    <GameVignette game={game} />
                  </li>
                ))}
            </ul>
          </div>

          {selectGameId && (
            <NewPostForm
              userId={props.userId}
              setNewPostTrigger={props.setNewPostTrigger}
              selectGameId={selectGameId}
              valueUserInfo={props.valueUserInfo}
              postValue={props.postValue}
              gamesList={gamesList}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default NewPost;
